type Section = "body" | "head";

export const appendScriptToDocument = (
  source: string,
  block: Section = "head",
) => {
  const bundle = document.createElement("script");
  bundle.setAttribute("type", "text/javascript");
  bundle.setAttribute("src", source);
  document[block].appendChild(bundle);
};

export const changeZIndex = (
  element: HTMLElement | undefined | null,
  changeBy = 1,
) => {
  if (!element) return;

  const currentZIndex = element.style.getPropertyValue("z-index");
  const newZIndex = Number(currentZIndex) + changeBy;
  element.style.setProperty("z-index", `${newZIndex > 0 ? newZIndex : 0}`);
};

/**
 * Returns the closest element (either the element itself or one of its ancestors) that has the
 * given class, or null if no such element exists.
 *
 * @param el The element from which to search.
 * @param className The class name to search for, or an array of class names to search for. If
 *                  an array is given, the element needs to match only one of the classes.
 */
export const findClosestElementWithClass = (
  element: HTMLElement | null,
  className: string | Array<string>,
) => {
  let currentElement = element;

  const hasClass = (el: HTMLElement) => {
    if (Array.isArray(className)) {
      return className.some((cn) => el?.classList.contains(cn));
    } else {
      return el?.classList.contains(className);
    }
  };

  while (currentElement && !hasClass(currentElement)) {
    currentElement = currentElement.parentElement;
  }

  return currentElement;
};
